module.exports = __webpack_public_path__ + "static/media/spinner.e4b6323e.gif";